import { SEARCH_STACK_SUGGESTIONS_DICTIONARY } from "constants/stack";

export const APPLY_FILTERS_SUGGESTIONS = {
  searchSuggestionsDictionary: SEARCH_STACK_SUGGESTIONS_DICTIONARY,
};
